import { createSelector } from 'reselect';

import { getApplicationDetail } from 'Console/data/applicationDetail/settings/SettingsSelector';

export const selectSegments = createSelector([getApplicationDetail], ({ segments }) => segments);
export const selectSegmentList = createSelector([selectSegments], ({ list }) => list);

export const selectSegmentListData = createSelector([selectSegmentList], ({ data = [] }) => data);

export const selectSegmentsListDataError = createSelector(
    [selectSegmentList],
    ({ hasError = false }) => hasError
);
export const selectSegmentsListDataIsLoading = createSelector(
    [selectSegmentList],
    ({ isLoading = false }) => isLoading
);
